/**
 * Session Service — aligned with AUTH_V2_REACT_FRONTEND_DOCS.md
 *
 * Handles listing and deleting sessions through the authenticated Auth V2
 * session endpoints.
 */
import axiosInstance from "@/config/axiosInstance";
import { getAuthApiRoute } from "@/helpers/api.util";

export const normalizeSessions = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.sessions)) return payload.sessions;
    return [];
};

export const isWithinSessionLimit = (sessions, maxSessionCount) =>
    Array.isArray(sessions) &&
    Number.isFinite(maxSessionCount) &&
    sessions.length <= maxSessionCount;

// ---------------------------------------------------------------------------
// Authenticated Session Management
// ---------------------------------------------------------------------------

/**
 * Get all active sessions for the current user.
 *
 * GET /sessions  (Bearer)
 * @returns {Session[]}
 */
export const getSessions = async ({ accessToken } = {}) => {
    const { data } = await axiosInstance.get(getAuthApiRoute("sessions"), {
        ...(accessToken
            ? { headers: { Authorization: `Bearer ${accessToken}` } }
            : {}),
        ...(accessToken ? { skipAuthRefresh: true } : {}),
    });
    return normalizeSessions(data.data);
};

/**
 * Delete a specific session.
 *
 * DELETE /session  (Bearer)
 * @param {string} sessionId
 */
export const deleteSession = async (sessionId, { accessToken } = {}) => {
    const { data } = await axiosInstance.delete(getAuthApiRoute("session"), {
        data: { sessionId },
        ...(accessToken
            ? { headers: { Authorization: `Bearer ${accessToken}` } }
            : {}),
        ...(accessToken ? { skipAuthRefresh: true } : {}),
    });
    return data.data;
};
